import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import config from './config'
import {SIDRender, SLowcodeList, STags} from 'shj-components'
import { apiData2Table } from '@/utils/data'
import { TabComponentInterface } from '../../../index.d'
import { useNavigate, useParams } from 'react-router-dom'
import {getMeasureRoomPage} from "@/services/crmTool.ts";
export const measureTagConfig = {
  canceled: {
    label: '已取消',
    fontColor: '#a4a4a4',
    bgColor: '#ececec'
  },
  waitingMeasure: {
    label: '待量房',
    fontColor: '#119d6f',
    bgColor: '#bcebdc'
  },
  measured: {
    label: '已量房',
    fontColor: '#ee4d6e',
    bgColor: '#fadddd'
  },
  auditing: {
    label: '审核中',
    fontColor: '#e1742b',
    bgColor: '#f9e0c7'
  },
  completed: {
    label: '已完成',
    fontColor: '#7272f1',
    bgColor: '#cacaff'
  }
}

const MeasureRoomLog = forwardRef<TabComponentInterface>((_, ref) => {
  const navigate = useNavigate()
  const { id } = useParams();
  const listRef = useRef<any>()
  useImperativeHandle(ref, () => ({
    openSettingModal: () => {
      listRef.current?.openSetting?.()
    },
  }))

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      const data = {...query,customerIds:id?[id]:[]}
      console.log(111,data)
      getMeasureRoomPage({
        params: {pageId: current, pageSize},
        data,
      }).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const extension = {
    request: { fetchList },
    events: {},
    status: {},
    customRender: {
      // 商机渲染
      businessIdRender(text, record: Record<string, any>) {
        const returnUrl = `/CrmPlus/customerProfileDetail/${id}`;
        return (
          <SIDRender
            id={text}
            onClick={() => {
              navigate(`/saleOp/salesWorkBench/salesWorkBenchDetail/${record?.clueId}?templateNodeId=${text}&returnUrl=${returnUrl}`)
            }}
          />
        )
      },
      stateRender(text) {
        return <STags itemKey={text} style={{borderRadius: 5, padding: '5px 8px'}} config={measureTagConfig}/>
      },
    },
  }

  return <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
})

export default MeasureRoomLog
